import theme from '@styles/theme';
export default {
  section: {
    position: 'relative',
    zIndex: theme.zIndex.documentUp,
    width: '100%',
    background: theme.rawColors.beige500,
    pt: ['64px', '64px', '10.4166667vw', '10.4166667vw', '6.11111111vw', '6.11111111vw', '6.04166667vw'],
    pb: [0, 0, '10.4166667vw', '10.4166667vw', '6.11111111vw', '6.11111111vw', '6.04166667vw'],
    px: [0, 0, '5.20833333vw', '5.20833333vw', 0]
  },
  box: {
    width: ['100%', '100%', '27.7773438vw', '27.7773438vw', '22.3611111vw', '22.3611111vw', '23.0208333vw'],
    display: 'flex',
    flexDirection: 'column'
  },
  imageContainer: {
    position: 'relative',
    width: '100%',
    height: ['73.6vw', '73.6vw', '21.6145833vw', '21.6145833vw', '16.4583333vw', '16.4583333vw', '16.9270833vw']
  },
  textContainer: {
    mt: ['64px', '64px', '24px'],
    mx: ['40px', '40px', 0],
    mb: ['64px', '64px', 0]
  },
  buttonContainer: {
    mt: ['64px', '64px', '24px'],
    mx: ['40px', '40px', 0],
    mb: ['64px', '64px', 0]
  },
  image: {
    width: '100%',
    height: 'auto',
    objectFit: 'cover',
    objectPosition: 'center'
  },
  featuresContainer: {
    maxWidth: ['100%', '100%', '100%', '100%', '78.4722222vw', '78.4722222vw', '79.6875vw'],
    width: '100%',
    margin: '0 auto'
  },
  heading: {
    px: ['40px', '40px', '0']
  },
  flexRow: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: ['wrap', 'wrap', 'nowrap']
  }
};